// extracted by mini-css-extract-plugin
export default {"categoriesBlock":"CompanyTabs_categoriesBlock__-Yn7I","container":"CompanyTabs_container__aNgr9","category":"CompanyTabs_category__xJ3VK","active":"CompanyTabs_active__zkDKl"};